module.exports = __webpack_public_path__ + "img/hotelFamily-6.60b58bb0.jpg";